import React from 'react'
import gql from 'graphql-tag'
import Query from 'components/shared/Query'
import ProductHeading from './ProductHeading'
import DefaultProductStatus from './DefaultProductStatus'

import AdvertisingProduct from './Products/AdvertisingProduct'
import AreaPhotoProduct from './Products/AreaPhotoProduct'
import CollageProduct from './Products/CollageProduct'
import DigitalPlanDrawingProduct from './Products/DigitalPlanDrawingProduct'
import DigitalStylingProduct from './Products/DigitalStylingProduct'
import Drone360Product from './Products/Drone360Product'
import DronePhotoProduct from './Products/DronePhotoProduct'
import DronePremiumPhotoProduct from './Products/DronePremiumPhotoProduct'
import ElevatedPhotoProduct from './Products/ElevatedPhotoProduct'
import EnergyLabelingProduct from './Products/EnergyLabelingProduct'
import EveningPhotoProduct from './Products/EveningPhotoProduct'
import ExclusivePhotoProduct from './Products/ExclusivePhotoProduct'
import FacadePhotoProduct from './Products/FacadePhotoProduct'
import FlexiblePremiumPhotoProduct from './Products/FlexiblePremiumPhotoProduct'
import FloorPlansProduct from './Products/FloorPlansProduct'
import LocalAreaPhotoProduct from './Products/LocalAreaPhotoProduct'
import MastPremiumPhotoProduct from './Products/MastPremiumPhotoProduct'
import Object360Product from './Products/Object360Product'
import PanoramaPhotoProduct from './Products/PanoramaPhotoProduct'
import PlanDrawingProduct from './Products/PlanDrawingProduct'
import PortraitPhotoProduct from './Products/PortraitPhotoProduct'
import PremiumHighPhotoProduct from './Products/PremiumHighPhotoProduct'
import PremiumPhotoProduct from './Products/PremiumPhotoProduct'
import PrePhotoProduct from './Products/PrePhotoProduct'
import RetouchedEveningPhotoProduct from './Products/RetouchedEveningPhotoProduct'
import RetouchedPhotoProduct from './Products/RetouchedPhotoProduct'
import SlideshowProduct from './Products/SlideshowProduct'
import SlidesProduct from './Products/SlidesProduct'
import Some10Product from './Products/Some10Product'
import StandardPhotoProduct from './Products/StandardPhotoProduct'
import StylingProduct from './Products/StylingProduct'
import VideoProduct from './Products/VideoProduct'
import VirtualTourProduct from './Products/VirtualTourProduct'
import VisoProduct from './Products/VisoProduct'
import WalkthroughProduct from './Products/WalkthroughProduct'

const components = {
  AdvertisingProduct,
  AreaPhotoProduct,
  CollageProduct,
  DigitalPlanDrawingProduct,
  DigitalRetouchedFurnishingPhotoProduct: RetouchedPhotoProduct,
  DigitalRetouchedRenovationPhotoProduct: RetouchedPhotoProduct,
  Drone360Product,
  DronePhotoProduct,
  DronePremiumPhotoProduct,
  ElevatedPhotoProduct,
  EnergyLabelingProduct,
  EveningPhotoProduct,
  ExclusivePhotoProduct,
  FacadePhotoProduct,
  FlexiblePremiumPhotoProduct,
  FloorPlansProduct,
  LocalAreaPhotoProduct,
  MastPremiumPhotoProduct,
  Object360Product,
  PanoramaPhotoProduct,
  PlanDrawingProduct,
  PortraitPhotoProduct,
  PremiumHighPhotoProduct,
  PremiumPhotoProduct,
  PrePhotoProduct,
  RetouchedEveningPhotoProduct: RetouchedEveningPhotoProduct,
  SlideshowProduct,
  SlidesProduct,
  Some10Product,
  StandardPhotoProduct,
  StylingProduct,
  DigitalStylingProduct,
  VideoProduct,
  VirtualTourProduct,
  VisoProduct,
  WalkthroughProduct,
}

const productQuery = gql`
  query ProductQuery($id: ID!) {
    product(id: $id) {
      id
      name
      state
      requiresUserInput
      canProvideUserInput
      createdAt
      deliveredAt
      deliveryRating {
        id
        rating
      }
      ...on PhotoEditingBasedProduct {
        editingComponentIds
      }
      ...on PhotoBasedProduct {
        quantity
      }
      ...on AssetsBasedProduct {
        remainingCredits
        extraAssetUnitPrice
        assets {
          edges {
            approved
            node {
              id
              state
              ...on PhotoAsset {
                image(size: "monitor") {
                  url
                  thumbUrl
                  width
                  height
                  labels
                  filenameIndex
                }
              }
            }
          }
        }
      }
      ...StandardPhotoProduct
      ...ExclusivePhotoProduct
      ...PremiumHighPhotoProduct
      ...DronePremiumPhotoProduct
      ...PrePhotoProduct
      ...DronePhotoProduct
      ...ElevatedPhotoProduct
      ...LocalAreaPhotoProduct
      ...MastPremiumPhotoProduct
      ...EveningPhotoProduct
      ...FacadePhotoProduct
      ...FlexiblePremiumPhotoProduct
      ...FloorPlansProduct
      ...PlanDrawingProduct
      ...DigitalPlanDrawingProduct
      ...PanoramaPhotoProduct
      ...PremiumPhotoProduct
      ...RetouchedPhotoProduct
      ...RetouchedEveningPhotoProduct
      ...CollageProduct
      ...VideoProduct
      ...VisoProduct
      ...WalkthroughProduct
      ...StylingProduct
      ...DigitalStylingProduct
      ...SlideshowProduct
      ...SlidesProduct
      ...EnergyLabelingProduct
      ...VirtualTourProduct
      ...PortraitPhotoProduct
      ...Drone360Product
      ...Object360Product
    }
    viewer {
      id
      photoOrderPreference {
        edges {
          node {
            id
            name
          }
        }
      }
      customer {
        id
        canCreateCorrections
        canRateProductDelivery
        customProfiles
      }
      broker {
        id
        name
        email
        phone
        productAvailability {
          videoFacts {id, name, optional}
          videoTypes {
            id, name, type, extraProductOptions
            features {
              id, name, placeholder, optional, customizable
              extraFeatures {id, placeholder, optional, short}
            }
          }
        }
      }
    }
  }
  ${StandardPhotoProduct.fragment}
  ${ExclusivePhotoProduct.fragment}
  ${PremiumHighPhotoProduct.fragment}
  ${DronePremiumPhotoProduct.fragment}
  ${PrePhotoProduct.fragment}
  ${DronePhotoProduct.fragment}
  ${ElevatedPhotoProduct.fragment}
  ${LocalAreaPhotoProduct.fragment}
  ${MastPremiumPhotoProduct.fragment}
  ${EveningPhotoProduct.fragment}
  ${FacadePhotoProduct.fragment}
  ${FlexiblePremiumPhotoProduct.fragment}
  ${FloorPlansProduct.fragment}
  ${PlanDrawingProduct.fragment}
  ${DigitalPlanDrawingProduct.fragment}
  ${PanoramaPhotoProduct.fragment}
  ${PremiumPhotoProduct.fragment}
  ${RetouchedPhotoProduct.fragment}
  ${RetouchedEveningPhotoProduct.fragment}
  ${CollageProduct.fragment}
  ${VideoProduct.fragment}
  ${VisoProduct.fragment}
  ${WalkthroughProduct.fragment}
  ${StylingProduct.fragment}
  ${DigitalStylingProduct.fragment}
  ${SlideshowProduct.fragment}
  ${SlidesProduct.fragment}
  ${EnergyLabelingProduct.fragment}
  ${VirtualTourProduct.fragment}
  ${Drone360Product.fragment}
  ${Object360Product.fragment}
  ${PortraitPhotoProduct.fragment}
`

const Product = ({match}) => {
  return (
    <Query
      inlineLoading
      inlineError
      query={productQuery}
      variables={{
        id: match.params.productId,
      }}
    >
      {({getData}) => {
        const product = getData('product')
        const viewer = getData('viewer')
        const ProductComponent = components[product.__typename] || DefaultProductStatus

        return (
          <>
            <ProductHeading
              product={product}
              canRateProductDelivery={viewer.customer.canRateProductDelivery}
            />
            <ProductComponent
              match={match}
              product={product}
              viewer={viewer}
            />
          </>
        )
      }}
    </Query>
  )
}

export default Product
